export enum BuyerTypes {
    Agents = 'agents',
    Companies = 'companies',
}

interface Args {
    buyerAgentId: string | undefined | null
    buyerAgentName: string | undefined | null
}

export const returnBuyerType = ({ buyerAgentId, buyerAgentName }: Args): string => {
    return buyerAgentId && buyerAgentName?.trim().length ? BuyerTypes.Agents : BuyerTypes.Companies
}

export default returnBuyerType
